export const ENTRY_DATA_DEAL_TYPE_AND_STATUS = "Deal Type & Status";

export const ENTRY_DATA_DEAL_TYPE_AND_STATUS_KEYS = {
  dealType: "Deal Type",
  dealStatus: "Deal Status",
  dealName: "Deal Name",
} as const;
